import Vue from "vue";
import ElementUI from "element-ui";
import VueLazyLoad from "vue-lazyload";
import MetaInfo from 'vue-meta-info';
import VueCropper from 'vue-cropper'
import infiniteScroll from 'vue-infinite-scroll'
import "element-ui/lib/theme-chalk/index.css";

import i18n from '@/languages/i18n';
import "@/assets/styles/iconfont.css";
import '@/assets/core.js';
import util from "@/assets/util.js";
import utils from "@/assets/jsonutils.js";
import htmlToPdf from '@/util/htmlToPdf'
import comm from "@/assets/comm.js";
import validate from "@/assets/validate.js";
import * as filters from "@/util/filters";
import testLog from "@/util/log";
import enums from "@/util/enum";
import tools from "@/util/tools";
import pcLinkMobile from '@/util/mobileLink';
import Axios from '@/util/axios';
import App from "@/App";
import router from "@/router";
import store from '@/store/store';

Vue.use(validate);
Vue.use(util);
Vue.use(MetaInfo)
Vue.use(VueCropper)
Vue.use(VueLazyLoad);
Vue.use(ElementUI);
Vue.use(infiniteScroll)
Vue.use(htmlToPdf)

Vue.config.productionTip = false;

Vue.prototype.$http = Axios;
Vue.prototype.$log = testLog;
Vue.prototype.enums = enums;
Vue.prototype.$jsonUtils = utils;
Vue.prototype.timeStamp = tools.dateFormatter;
Vue.prototype.mydateFormat = tools.dateFormat;
Vue.prototype.delHtmlTag = function (str) {
  return str.replace(/<[^>]+>/g, "");
};

Vue.prototype.isHtml = function (value) {
  if (value == null) return false;
  if (String(value).indexOf('<') != -1 && String(value).indexOf('>') != -1) {
    return true;
  } else {
    return false;
  }
}

//埋点
Vue.prototype.buriedPoint = function (flag,param) {
  this.$http.get("/api/data/col?flag=" + flag + '&param=' + param).then((res)=>{
        
  })
}
//运营位跳转
Vue.prototype.openLocatione = function (item) {
  if (item.maType == "1") {
    let routeData = this.$router.resolve({
      path: "/video/detail?id=" + item.maId,
    });
    window.open(routeData.href, "_blank");
  }
  if (item.maType == "2") {
    let routeData = this.$router.resolve({
      path: "/peopleCenter/" + item.maId + "/home",
    });
    window.open(routeData.href, "_blank");
  }
  if (item.maType == "3") {
    let routeData = this.$router.resolve({
      path: "/article/detail/" + item.maId,
    });
    window.open(routeData.href, "_blank");
  }
  if (item.maType == "4") {
    let routeData = this.$router.resolve({
      path: "/activityDetail/" + item.maId,
    });
    window.open(routeData.href, "_blank");
  }
  if (item.maType == "5") {
    let routeData = this.$router.resolve({
      path: "/subjectDetail/" + item.maId + "/home",
    });
    window.open(routeData.href, "_blank");
  }
  if (item.maType == "6") {
    let routeData = this.$router.resolve({
      path: "/live/liveDetail?id=" + item.maId,
    });
    window.open(routeData.href, "_blank");
  }
  if (item.maType == "7") {
    window.open(item.link, "_blank");
  }
  if (item.maType == "8") {
    let routeData = this.$router.resolve({
      path: "/recruitDetail/" + item.maId,
    });
    window.open(routeData.href, "_blank");
  }
  if (item.maType == "9") {
    let routeData = this.$router.resolve({
      path: "/peopleCenter/" + item.maId + "/recruit",
    });
    window.open(routeData.href, "_blank");
  }
  if (item.maType == "10") {
    let routeData = this.$router.resolve({
      path: "/jobs/home",
    });
    window.open(routeData.href, "_blank");
  }
}

//时间戳转时间  type 1:当前年份不显示 2:当前年份显示
Vue.prototype.formatDate = function (value, type) {
  let date = new Date(value);
  let now = new Date();
  let nowYear = now.getFullYear();
  let y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? ('0' + MM) : MM;
  let d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  let h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  let m = date.getMinutes();
  m = m < 10 ? ('0' + m) : m;
  let s = date.getSeconds();
  s = s < 10 ? ('0' + s) : s;
  if (y == nowYear && type == 1) {
    return MM + '-' + d + ' ' + ' ' + h + ':' + m ;
  }
  return y + '-' + MM + '-' + d + ' ' + ' ' + h + ':' + m ;
}

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

if (!/^\/video\/\d*$/.test(window.location.pathname)) {
  pcLinkMobile();
};


const auth_token = comm.getUrlParam("auth_token");
if (auth_token) {
  localStorage.setItem("auth_token", auth_token);
}

const app = new Vue({
  el: "#app",
  router,
  store,
  i18n,
  components: { App },
  template: "<App/>",
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
});

export default app;



// WEBPACK FOOTER //
// ./src/main.js